import { apiPost, apiPut, apiDelete, apiGet } from '../lib/api'

export const SAMPLE_HOMEWORKS_CREATE_START = 'SAMPLE_HOMEWORKS_CREATE_START'
export const SAMPLE_HOMEWORKS_CREATE_SUCCESS = 'SAMPLE_HOMEWORKS_CREATE_SUCCESS'
export const SAMPLE_HOMEWORKS_CREATE_ERROR = 'SAMPLE_HOMEWORKS_CREATE_ERROR'

export const HOMEWORK_SAVE_START = 'HOMEWORK_SAVE_START'
export const HOMEWORK_SAVE_SUCCESS = 'HOMEWORK_SAVE_SUCCESS'
export const HOMEWORK_SAVE_ERROR = 'HOMEWORK_SAVE_ERROR'

export const HOMEWORK_ADD_START = 'HOMEWORK_ADD_START'
export const HOMEWORK_ADD_SUCCESS = 'HOMEWORK_ADD_SUCCESS'
export const HOMEWORK_ADD_ERROR = 'HOMEWORK_ADD_ERROR'

export const HOMEWORK_CLEAR_DETAIL = 'HOMEWORK_CLEAR_DETAIL'
export const HOMEWORKS_CLEAR = 'HOMEWORK_CLEAR'

export const HOMEWORK_EDIT_START = 'HOMEWORK_EDIT_START'
export const HOMEWORK_EDIT_SUCCESS = 'HOMEWORK_EDIT_SUCCESS'
export const HOMEWORK_EDIT_ERROR = 'HOMEWORK_EDIT_ERROR'

export const HOMEWORK_DELETE_START = 'HOMEWORK_DELETE_START'
export const HOMEWORK_DELETE_SUCCESS = 'HOMEWORK_DELETE_SUCCESS'
export const HOMEWORK_DELETE_ERROR = 'HOMEWORK_DELETE_ERROR'

export const HOMEWORK_LOAD_START = 'HOMEWORK_LOAD_START'
export const HOMEWORK_LOAD_SUCCESS = 'HOMEWORK_LOAD_SUCCESS'
export const HOMEWORK_LOAD_ERROR = 'HOMEWORK_LOAD_ERROR'

export const HOMEWORKS_LOAD_START = 'HOMEWORKS_LOAD_START'
export const HOMEWORKS_LOAD_SUCCESS = 'HOMEWORKS_LOAD_SUCCESS'
export const HOMEWORKS_LOAD_ERROR = 'HOMEWORKS_LOAD_ERROR'

export const GET_PUBLIC_HOMEWORKS_START = 'GET_PUBLIC_HOMEWORKS_START'
export const GET_PUBLIC_HOMEWORKS_SUCCESS = 'GET_PUBLIC_HOMEWORKS_SUCCESS'
export const GET_PUBLIC_HOMEWORKS_ERROR = 'GET_PUBLIC_HOMEWORKS_ERROR'

export const SET_CURRENT_HOMEWORK = 'SET_CURRENT_HOMEWORK'

export const loadHomeworks = () => ({ getState, fetch }) => ({
  type: 'HOMEWORKS_LOAD',
  payload: apiGet({
    fetch,
    endpoint: 'homework',
    getState,
  }),
})

export const createHomework = (body) => ({ getState, fetch }) => ({
  type: 'HOMEWORK_ADD',
  payload: apiPost({
    fetch,
    endpoint: 'homework',
    getState,
    body,
  }),
})

export const editHomework = (body) => ({ getState, fetch }) => ({
  type: 'HOMEWORK_EDIT',
  payload: apiPut({
    fetch,
    endpoint: `homework/${body.id}`,
    getState,
    body,
  }),
})

export const loadHomeworkDetail = (id) => ({ getState, fetch }) => ({
  type: 'HOMEWORK_LOAD',
  payload: apiGet({
    fetch,
    endpoint: `homework/${id}`,
    getState,
  }),
})

export const deleteHomework = (id) => ({ getState, fetch }) => ({
  type: 'HOMEWORK_DELETE',
  payload: apiDelete({
    fetch,
    endpoint: `homework/${id}`,
    getState,
  }),
})

export const setCurrentHomework = (homework) => ({
  type: SET_CURRENT_HOMEWORK,
  payload: homework,
})

export const clearHomeworkDetail = () => ({
  type: HOMEWORK_CLEAR_DETAIL,
})

export const clearHomeworks = () => ({
  type: HOMEWORKS_CLEAR,
})

/* **************************************/
/* **************************************/
/* **************************************/

export const getPublicHomeworks = (query) => ({ getState, fetch }) => ({
  type: 'GET_PUBLIC_HOMEWORKS',
  payload: apiGet({
    fetch,
    endpoint: `/homework/search/public/${query}`,
    getState,
  }),
})

export const savePublicHomework = (id) => ({ getState, fetch }) => ({
  type: 'HOMEWORK_SAVE',
  payload: apiPost({
    fetch,
    endpoint: `/homework/favorite/${id}`,
    getState,
  }),
})

export const removePublicHomework = (id) => ({ getState, fetch }) => ({
  type: 'HOMEWORK_REMOVE_FAVORITE',
  payload: apiDelete({
    fetch,
    endpoint: `/homework/favorite/${id}`,
    getState,
  }),
})



// WEBPACK FOOTER //
// ./src/common/homeworks/actions.js